import {i18n} from '~/plugins/i18n'

// datatable tree
export function adminDataTreeConvert (data, adminId, { tickable } = {}) {
  const convResult = []
  const obj = {}
  const parent = data.filter(itm => itm.admin_id === adminId)[0]

  obj.label = parent.admin_name
  obj.admin_id = parent.admin_id

  let groupClass = parent.admin_type === 6 ? 'adminP' : 'adminR'
  const groupType = [0, 2, 5]
  if (groupType.indexOf(parent.admin_type) !== -1) {
    groupClass = 'adminB'
  }
  // obj.name = `<span class="jsgrid-cell-child ${groupClass}">${parent.admin_name}</span>`
  obj.type = parent.admin_type
  obj.groupClass = groupClass
  obj.name = `${parent.admin_name}`
  obj.level = parent.lv
  if (typeof parent.btnLabel !== 'undefined') {
    obj.btnLabel = parent.btnLabel
  }
  if (parent.avatar !== undefined) {
    obj.avatar = parent.avatar
  }
  if (parent.icon !== undefined) {
    obj.icon = parent.icon
  }
  if (parent.img !== undefined) {
    obj.img = parent.img
  }
  if (typeof tickable !== 'undefined') {
    obj.tickable = tickable
  }
  obj.header = 'custom'
  // children data
  const child = data.filter((itm) => {
    return itm.parent_admin_id === adminId
  })

  if (child.length > 0) {
    obj.children = []
    child.forEach((item) => {
      const objChild = adminDataTreeConvert(data, item.admin_id, { tickable })
      obj.children.push(objChild[0])
    })
  }
  convResult.push(obj)
  return convResult
}

export function getParentTreeItem (orgData, data, parentId) {
  const $parent = orgData.filter((itm) => {
    return itm.admin_id === parentId
  })
  if ($parent.length > 0) {
    if (!data.includes($parent[0])) {
      data.push($parent[0])
    }
    const $parentsData = orgData.filter((itm) => {
      return itm.admin_id < parentId
    })
    if ($parentsData.length > 0) {
      $parentsData.forEach(() => {
        getParentTreeItem(orgData, data, $parent[0].parent_admin_id)
      })
    }
  }
  return data
}

// 원본키값을 다른 키 값으로 추가
export function setChildKeyChange (v, chng) {
  Object.keys(chng).forEach((item) => {
    v[item] = v[chng[item]]
  })

  if (Object.keys(v).includes('children')) {
    v.children.forEach((item, index) => {
      v.children[index] = setChildKeyChange(item, chng)
    })
  }
  return v
}

// 원본키값을 다른 키 값으로 추가 값의 형을 무조건 string
export function setChildKeyValToStringChange (v, chng) {
  Object.keys(chng).forEach((item) => {
    if (typeof v[chng[item]] !== 'undefined') {
      v[item] = v[chng[item]].toString()
    }
  })

  if (Object.keys(v).includes('children')) {
    v.children.forEach((item, index) => {
      v.children[index] = setChildKeyValToStringChange(item, chng)
    })
  }
  return v
}

export function setChildValChange (v, chng) {
  Object.keys(chng).forEach((item) => {
    v[item] = chng[item]
  })

  if (Object.keys(v).includes('children')) {
    v.children.forEach((item, index) => {
      v.children[index] = setChildValChange(item, chng)
    })
  }
  return v
}

// adminTree path 정보 가져오기
// v : admingroup tree, id : admin_id
export function arrFullPathName (v, id) {
  const temp = []
  const pathName = []
  if (_.isArray(v)) {
    v.forEach((item) => {
      const s = arrFullPathName(item, id)
      s.forEach(d => {
        temp.push(d)
      })
    })
  } else {
    if (v.admin_id === id) {
      temp.push(v.name)
    }
    if (Object.keys(v).includes('children')) {
      v.children.forEach((item) => {
        const ar = arrFullPathName(item, id)
        ar.forEach(d => {
          temp.push(d)
        })
        if (_.isArray(ar) && ar.length > 0) {
          pathName.unshift(v.name)
        }
      })
    }
  }
  return pathName.concat(temp)
}

// obj = {id: 'menu_id', val: 1}
export function arrParentNodesRoleChange (v, obj, roleType) {
  const temp = []
  const pathName = []
  if (_.isArray(v)) {
    v.forEach((item) => {
      const s = arrParentNodesRoleChange(item, obj, roleType)
      s.forEach(d => {
        temp.push(d)
      })
    })
    return pathName.concat(temp)
  }
  if (v[obj.id] === obj.val) temp.push(v[obj.id])
  if (Object.keys(v).includes('children')) {
    v.children.forEach((item) => {
      const ar = arrParentNodesRoleChange(item, obj, roleType)
      ar.forEach(d => {
        temp.push(d)
      })
      if (_.isArray(ar) && ar.length > 0) {
        if (typeof roleType !== 'undefined') v.admin_menu_role_type = roleType
        pathName.unshift(v[obj.id])
      }
    })
  }
  return pathName.concat(temp)
}

// where = {id: menu_id, val: 1} , getKeyValue: 'name'
export function getChildrenFindVal (v, where, getValue) {
  let retVal = null
  if (_.isArray(v)) {
    for (let i = 0; i < v.length; i++) {
      retVal = getChildrenFindVal(v[i], where, getValue)
      if (!fnIsBlank(retVal)) break
    }
    return retVal
  }
  if (v[where.id] === where.val) {
    retVal = v[getValue]
    return retVal
  }
  if (fnIsBlank(retVal) && Object.keys(v).includes('children')) {
    for (let i = 0; i < v.children.length; i++) {
      retVal = getChildrenFindVal(v.children[i], where, getValue)
      if (!fnIsBlank(retVal)) break
    }
  }
  return retVal
}

export function parseErrorMessage (val) {
  const msg = val.match(/(\d+[^:])\s*:\s*\{['"](.+)['"]\}/)
  if (typeof val === 'string') {
    if (msg !== null) {
      return `${msg[1]} - ${msg[2]}`
    } else {
      return val
    }
  }
  return ''
}
export function fnIsBlank (val) {
  if (!val) {
    return true
  }
  if (typeof val === 'undefined') {
    return true
  }
  if (val === '') {
    return true
  }
  const isBlank = /^\s+$/g
  if (isBlank.test(val)) {
    return true
  }
  return false
}

// 공통코드 리스트 (selected)
export function fnGetCodeList (groupKey) {
  const code = i18n.t('code.code')
  const _code = code.filter(item => {
    return item.group_key === groupKey
  })
  if (_code.length > 0) {
    return _code[0].list.filter(item => {
      item.value = item.key
      item.label = item.val
      return item
    })
  }
  return []
}

// 코드 > 로그 필터 (리스트)
export function getCodeFilterList (groupKey) {
  const code = i18n.t('code.code')
  const _code = code.filter(item => {
    return item.group_key === groupKey
  })
  if (_code.length > 0) {
    return _code[0].list.filter(item => {
      item.select = false
      item.value = '' + item.key
      item.name = item.val
      return item
    })
  }
  return []
}

// 공통코드 > 그룹에 존재하는 키값
export function fnGetCodeVal (groupKey, key) {
  const list = fnGetCodeList(groupKey)
  const v = list.filter(item => {
    return item.key === key
  })
  if (v.length > 0 && _.isArray(v)) {
    return v[0].val
  }
  return ''
}
export function fnGetCodeObj (groupKey, key) {
  const list = fnGetCodeList(groupKey)
  const v = list.filter(item => {
    return item.key === key
  })
  if (v.length > 0 && _.isArray(v)) {
    return v[0]
  }
  return {}
}

// 아이피 관련
// unsigned
export function fnU (n) {
  return n >>> 0
}

export function fnIp (n) {
  return [
    (n >>> 24) & 0xFF,
    (n >>> 16) & 0xFF,
    (n >>> 8) & 0xFF,
    (n >>> 0) & 0xFF
  ].join('.')
}

export function fnIpUnSinged (addr) {
  const m = addr.match(/\d+/g)
  const addr32 = m.slice(0, 4).reduce(function (a, o) {
    return fnU(+a << 8) + +o
  })
  return addr32
}

export function fnGetIpAddress (addr) {
  let ipItem = {}
  if (addr === undefined || addr === '' || addr === null) {
    return ipItem
  }
  // 형식 ip/24
  if (fnIp4CidrCheck(addr)) {
    ipItem = fnipAddress4(addr)
  } else {
    const iplst = addr.match(/(([0-9]{1,3}.){3}[0-9]{1,3})/g)
    // ip-ip
    if (_.isArray(iplst) && iplst.length > 1) {
      const uStIp = fnIpUnSinged(iplst[0].trim())
      const uEdIp = fnIpUnSinged(iplst[1].trim())
      if (uStIp < uEdIp) {
        ipItem = {
          startIp: iplst[0].trim(),
          endIp: iplst[1].trim(),
          expIp: `${iplst[0].trim()}-${iplst[1].trim()}`
        }
      }
    }
  }
  return ipItem
}

export function fnipAddress4 (addr) {
  const addr32 = fnIpUnSinged(addr)
  const m = addr.match(/\d+/g)
  const mask = fnU(~0 << (32 - +m[4]))
  const startIp = fnIp(fnU(addr32 & mask))
  const endIp = fnIp(fnU(addr32 | ~mask))
  return {
    startIp: startIp,
    endIp: endIp,
    expIp: addr
  }
}

export function fnIp4CidrCheck (addr) {
  const regIpExp = /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/igm
  return regIpExp.test(addr)
}

export function excelDownload (field, data, title, filename) {
  const excelData = []
  const th = field.map((item) => {
    return `<th>${item.title}</th>`
  })
  const headerKey = field.map((item) => {
    return item.name
  })
  const head = `<tr>${th.join('')}</tr>`
  if (data.length > 0) {
    data.forEach((item) => {
      let td = ''
      headerKey.forEach((key) => {
        if (item[key] !== undefined && item[key] !== null) {
          td = td + '<td>' + item[key].toString().replace(/\s/g, '&nbsp;') + '&nbsp;</td>'
        } else {
          td = td + `<td></td>`
        }
      })
      excelData.push(`<tr>${td}</tr>`)
    })
  } else { // 데이터가 작으면 DRM이 이상하게 걸리는 것 같음. 공백추가하여 정상처리 되도록 수정
    let td = ''
    headerKey.forEach(() => {
      td = td + '<td>' + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>'
    })
    excelData.push(`<tr>${td}</tr>`)
  }
  const html = `${title}<br><br><table>${head}${excelData.join('')}</table>`
  const uri = 'data:application/vnd.ms-excel;charset=utf-8,' + html
  const link = document.createElement('a')
  link.href = uri
  if (filename === undefined) {
    link.download = `${title}.xls`
  } else {
    link.download = filename
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

import { base64Encode } from '~/utils/base64'
export function excelDownloadInquiryList (field, data, title, filename) {
  const excelData = []
  const th = field.map((item) => {
    return `<th>${item.title}</th>`
  })
  const headerKey = field.map((item) => {
    return item.name
  })
  const head = `<tr>${th.join('')}</tr>`
  if (data.length > 0) {
    data.forEach((item) => {
      let td = ''
      let userName = ''
      headerKey.forEach((key) => {
        if (item[key] !== undefined && item[key] !== null) {
          if (key === 'pams_req_usr_name') {
            userName = `${item[key]}/${item['pams_req_rank_name']}/${item['pams_req_depart_name']}`
          } else {
            userName = item[key].toString().replace(/\s/g, '&nbsp;')
          }
          td = td + '<td>' + userName + '&nbsp;</td>'
        } else {
          td = td + `<td></td>`
        }
      })
      excelData.push(`<tr>${td}</tr>`)
    })
  } else { // 데이터가 작으면 DRM이 이상하게 걸리는 것 같음. 공백추가하여 정상처리 되도록 수정
    let td = ''
    headerKey.forEach(() => {
      td = td + '<td>' + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>'
    })
    excelData.push(`<tr>${td}</tr>`)
  }
  const html = `${title}<br><br><table>${head}${excelData.join('')}</table>`
  const uri = 'data:application/vnd.ms-excel;base64,' + base64Encode(html)
  const link = document.createElement('a')
  link.href = uri
  if (filename === undefined) {
    link.download = `${title}.xls`
  } else {
    link.download = filename
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// -------------------------- common ------
export function fnDateformat (val) {
  const dt = new Date(val)
  let str = ''
  if (_.isDate(dt)) {
    const y = dt.getFullYear()
    let m = (dt.getMonth() + 1)
    let d = dt.getDate()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    str = y + '-' + m + '-' + d
  }
  return str
}

export function fnDateTimeformat (val) {
  const dt = new Date(val)
  let str = ''
  if (_.isDate(dt)) {
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1)
    const d = dt.getDate()
    const h = dt.getHours()
    const i = dt.getMinutes()
    const s = dt.getSeconds()
    str = y + '-' + (m > 9 ? m : '0' + m) + '-' + (d > 9 ? d : '0' + d) + ' ' + (h > 9 ? h : '0' + h) + ':' + (i > 9 ? i : '0' + i) + ':' + (s > 9 ? s : '0' + s)
  }
  return str
}

export function getTreeData (data, option) {
  const returnTree = []
  const sameleLevel = data.filter((item) => {
    return item[option.level] === data[0][option.level]
  })
  sameleLevel.forEach(element => {
    const id = element[option.id]
    returnTree.push(treeConvert(data, id, option)[0])
  })
  return returnTree
}

// option { id: 'menu_id', parent:'parent_menu_id',label: 'label', level: 'lv' }
export function treeConvert (data, id, option) {
  const convResult = []
  let obj = {}
  const parent = data.filter(function (itm) {
    return itm[option.id] === id
  })
  obj = parent[0]
  obj.label = parent[0][option.label]
  obj.level = parent[0][option.level]
  obj.header = 'custom'
  obj.selectableNodes = true

  const child = data.filter(function (itm) {
    return itm[option.parent] === id
  })
  if (child.length > 0) {
    obj.children = []
    child.forEach((item) => {
      const objChild = treeConvert(data, item[option.id], option)
      obj.children.push(objChild[0])
    })
  }
  convResult.push(obj)
  return convResult
}

// eventMessageObj(eventCodelist, '277011xx1', {menu:[110201], now:100, thold:80})
export function eventMessageObj (eventCodeList, eventCode, option) {
  let objOption = {}
  if (option === null || typeof option === 'undefined') {
    objOption = {}
  } else {
    objOption = JSON.parse(option)
  }
  const regEvent = /^[0-9]{5,6}(x{0,3})[0-9]{0,4}$/
  const strCode = '' + eventCode
  let ret = {}
  eventCodeList.forEach(item => {
    const pos = item.key.indexOf('x')
    if (pos > -1) {
      const math = item.key.match(regEvent)
      const xLen = math ? math[1].length : -1
      // xx value
      let xVal = ''
      if (xLen > -1) {
        xVal = strCode.substring(pos, pos + xLen)
      }
      const _compareEventCode = item.key.replace(math[1], xVal)

      if (_compareEventCode === strCode) {
        ret['key'] = item.key
        ret['name'] = item.name.replace('{' + math[1] + '}', xVal)
        ret['message'] = item.message.replace('{' + math[1] + '}', xVal)
        Object.keys(objOption).forEach(o => {
          if (o === 'message' && ret['message'].trim() === '') {
            ret['message'] = objOption[o]
          } else if (o !== 'menu') {
            ret['message'] = ret['message'].replace('{' + o + '}', objOption[o])
          }
        })
        return ret
      }
    } else {
      if (item.key === strCode) {
        ret = item
        Object.keys(objOption).forEach(o => {
          if (o === 'message' && ret['message'].trim() === '') {
            ret['message'] = objOption[o]
          } else if (o !== 'menu') {
            ret['message'] = ret['message'].replace('{' + o + '}', objOption[o])
          }
        })
        return ret
      }
    }
  })
  return ret
}

// json to Form data
export function jsonToFromData (dic) {
  const formData = new FormData()
  Object.keys(dic).forEach((key) => {
    formData.append(key, dic[key])
  })
  return formData
}

// 로딩 dialog호출 str: 버튼라벨, int: timeout, obj
export function fnLoadingDialog ($self, msg, option) {
  let stopButton = false
  let message = ''
  let timeout = 0

  if (_.isNumber(option)) {
    timeout = option
  }
  if (typeof option === 'boolean') {
    stopButton = option
  }
  if (_.isObject(option)) {
    if (typeof option['button'] !== 'undefined') {
      stopButton = option['button']
    }
    if (typeof option['timeout'] !== 'undefined') {
      timeout = option['timeout']
    }
  }

  if (typeof msg !== 'undefined') {
    message = msg
  }

  const dialog = {
    stopButton: stopButton,
    message: message
  }
  const $refLoading = refsFind($self, 'refLoadingDialog')

  if ($refLoading === null) {
    $self.$root.$children[1].$refs.globalLoadingDialog.message = ''
    $self.$root.$children[1].$refs.globalLoadingDialog.message = dialog.message
  } else {
    if (typeof $refLoading.$parent.loadingMessage !== 'undefined') {
      $refLoading.$parent.loadingMessage = dialog.message
    }
    if (typeof $refLoading.$parent.isStop !== 'undefined') {
      $refLoading.$parent.isStop = dialog.stopButton
    }
    $refLoading.show()
  }
  if (timeout > 0) {
    if ($refLoading === null) {
      setTimeout(() => {
        $self.$root.$children[1].$refs.globalLoadingDialog.hide()
      }, timeout)
    } else {
      setTimeout(() => {
        $refLoading.hide()
      }, timeout)
    }
  }
}

export function fnLoadingDialogHide ($self) {
  const $refLoading = refsFind($self, 'refLoadingDialog')
  if ($refLoading === null) {
    $self.$root.$children[1].$refs.globalLoadingDialog.hide()
  } else {
    $refLoading.hide()
  }
}

// 사용자 layout confirm
// ~/components/pageComponents/pams/ruleAutoManage/popup/ConfirmPopup
// 필수 포함 <confirm-popup ref="refConfirm"></confirm-popup>
// 예: fnConfirm(this, '삭제할까요?', () => { alert('삭제') })
export function fnConfirm ($self, message, _callback, title) {
  const ref = refsFind($self, 'refConfirm')
  if (title === undefined) {
    ref.confirmTitle = ''
  } else {
    ref.confirmTitle = title
  }
  ref.confirm(message, _callback)
}

// 상위 refs 검색
export function refsFind ($self, refsName) {
  let refRet = null
  if ($self.$refs[refsName] === undefined) {
    if ($self.$parent !== undefined) {
      const tmp = refsFind($self.$parent, refsName)
      refRet = tmp
    }
  } else {
    return $self.$refs[refsName]
  }
  return refRet
}

export function fnSetVerifyClass (typeCode) {
  let _class = ''
  _class = 'ps-icon-req-11'
  if (typeCode !== 1) {
    _class = 'ps-icon-req-08'
    if (typeCode === 24) {
      _class = 'ps-icon-req-06'
    } else if (typeCode > 10 && typeCode <= 19) {
      _class = 'ps-icon-req-08'
    } else if (typeCode > 20 && typeCode <= 30) {
      _class = 'ps-icon-req-07'
    }
  }
  return _class
}

export function pamsReqStatusTypeClass (typeCode) {
  if (typeCode === 2) {
    return 'ps-icon-req-02'
  } else if (typeCode === 3) {
    return 'ps-icon-req-09'
  } else if (typeCode === 4) {
    return 'ps-icon-req-03'
  } else if (typeCode === 5 || typeCode === 6) {
    return 'ps-icon-req-04'
  } else if (typeCode === 7) {
    return 'ps-icon-req-11'
  } else if (typeCode === 8 || typeCode === 9) {
    return 'ps-icon-req-10'
  }
  return 'ps-icon-req-01'
}

export function isAdminGroup (type) {
  const groupType = [0, 2, 5, 20] // admin_type (0: 관리자 그룹, 2: 슈퍼 관리자 그룹, 5: 외부 인증 관리자 그룹, 20: SubTams 인증 그룹 )
  return groupType.indexOf(type) !== -1
}
